import PropTypes from "prop-types";

export const ColumnDefaultProps = {
  title: "",
  prefix: null,
  suffix: null,
  text: null,
  className: null,
  field: null,
  colSpan: null,
  rowSpan: null,
  isRenderInBody: false,
  isRenderAsRow: false,
  render: null
};

export const ColumnPropTypes = PropTypes.shape({
  // Заголовок
  title: PropTypes.string,
  // Префикс заголовка
  prefix: PropTypes.string,
  // Суффикс заголовка
  suffix: PropTypes.string,
  // Направление текста
  text: PropTypes.oneOf(["left", "right", "center"]),
  // Класс для колонки и элементов
  className: PropTypes.string,
  // Название поля из data
  field: PropTypes.string,
  // Рендеринг только в теле
  isRenderInBody: PropTypes.bool,
  // Рендеринг как строки
  isRenderAsRow: PropTypes.bool,
  // Рендеринг элемента
  render: PropTypes.func
});
